import { render, staticRenderFns } from "./Datalink.vue?vue&type=template&id=cc6a3624&"
import script from "./Datalink.vue?vue&type=script&lang=js&"
export * from "./Datalink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports